// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RRks","colBig":"styles_colBig__2F_mC","colSmall":"styles_colSmall__2ncM_","shopifyNameWrapper":"styles_shopifyNameWrapper__ndDvc"};